import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash.isempty';
import {
  readInstalled,
  Shape as InstalledShape,
} from 'next/entities/installed';
import { asRequest } from 'next/entities/requests';
import MagicIcon from './MagicIcon';
import { InstallWrapper } from './styled';

export function InstallButton({ installed = {} }) {
  if (installed.loading || !isEmpty(installed.data)) {
    return null;
  }

  return (
    <InstallWrapper forwardedAs={Link} to="/settings/installation">
      <MagicIcon />
      Install to publish
    </InstallWrapper>
  );
}

InstallButton.propTypes = {
  installed: asRequest(PropTypes.objectOf(InstalledShape)),
};

const mapStateToProps = state => ({
  installed: readInstalled(state),
});

export default connect(mapStateToProps)(InstallButton);
